import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import { faChevronUp } from "@jewlr/pro-regular-svg-icons/faChevronUp"
import PropTypes from "prop-types"
import { Suspense, useState } from "react"

import { ItemAction } from "areas/cart/components"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { to_currency } from "helpers/number"
import { hasHebrewChar } from "helpers/product/text-dir"

const LineItemDetails = ({ item }) => {
  const [showDetails, toggleShowDetails] = useState(false)

  if (!item?.view_item_details?.length) return null

  return (
    <div>
      <ItemAction
        aria-controls={`cart-item-details-${item.id}`}
        aria-expanded={showDetails}
        id={`cart-item-details-toggle-${item.id}`}
        onClick={() => toggleShowDetails(!showDetails)}
      >
        Item Details
        <FontAwesomeIcon
          className="text-10 ml-4"
          icon={showDetails ? faChevronUp : faChevronDown}
        />
      </ItemAction>
      {typeof window !== "undefined" && (
        <Suspense fallback={<div />}>
          <Expand id={`cart-item-details-${item.id}`} show={showDetails}>
            <div
              aria-labelledby={`cart-item-details-toggle-${item.id}`}
              className="text-14 mt-20 grid grid-cols-[max-content_1fr] gap-x-24 gap-y-10"
              role="table"
            >
              <div className="contents" role="row">
                <div className="shrink-0 font-semibold" role="rowheader">
                  Style Code
                </div>
                <div className="flex-1 font-medium" role="cell">
                  {item.style_code}
                </div>
              </div>
              {item.view_item_details.map((detail) => (
                <div
                  className="contents"
                  key={`${item.id}-detail-${detail.name}`}
                  role="row"
                >
                  <div className="shrink-0 font-semibold" role="rowheader">
                    {detail.label}
                  </div>
                  <div className="flex-1 font-medium" role="cell">
                    {detail.values ? (
                      <ul className="list-none">
                        {detail.values.map((value, i) => (
                          <li
                            key={`${item.id}-detail-${detail.name}-value-${i}`}
                          >
                            {value}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <>
                        <span
                          className="[&_a]:text-primary [&_a]:text-underline"
                          dangerouslySetInnerHTML={{ __html: detail.value }}
                          {...(hasHebrewChar(detail.value)
                            ? { dir: "auto" }
                            : {})}
                        />
                        {detail.price !== 0 && (
                          <span className="ml-4">
                            ({detail.name === "de" ? "" : "+"}
                            {to_currency(detail.price)})
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Expand>
        </Suspense>
      )}
    </div>
  )
}

LineItemDetails.propTypes = {
  item: PropTypes.object,
}

export default LineItemDetails
